<template>
    <div v-if="show" class="modal">
      <div class="modal-content">
        <h3>Biochar Facility Analysis</h3>
        <p>Enter radius for analysis:</p>
        <input v-model.number="radius" type="number" min="1" placeholder="Radius" />
        <select v-model="unit">
          <option value="kilometers">Kilometers</option>
          <option value="miles">Miles</option>
        </select>
        <button @click="submitQuery">Analyze</button>
        <button @click="closeModal">Cancel</button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "BiocharQueryModal",
    data() {
      return {
        show: false,
        radius: 10,
        unit: "kilometers",
      };
    },
    methods: {
      showModal() {
        this.show = true;
      },
      closeModal() {
        this.show = false;
        this.radius = 10;
        this.unit = "kilometers";
      },
      submitQuery() {
        this.$emit("onQuery", { radius: this.radius, unit: this.unit });
        this.closeModal();
      },
    },
  };
  </script>
  
  <style scoped>
 .modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  z-index: 1000;
  pointer-events: none
}
.modal-content {
  background: white;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 3rem 5rem rgba(0, 0, 0, 0.3);
  text-align: center;
  width: 300px;
  margin: 20px;
  pointer-events: auto
}
  input,
  select {
    margin: 10px;
    padding: 5px;
    border: 2px solid green;
    border-radius: 4px;
  }
  button {
    margin: 10px;
    padding: 8px 20px;
    background-color: #4caf50;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  button:hover {
    background-color: #3e8e41;
  }
  </style>